import { render, staticRenderFns } from "./anketIlgeeh.vue?vue&type=template&id=7a6d3e18&"
import script from "./anketIlgeeh.vue?vue&type=script&lang=js&"
export * from "./anketIlgeeh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports